module.exports = __webpack_public_path__ + "static/media/Profile.60e1211e.svg";